// src/blogs/MovieBlog.jsx
import React, { useState } from "react";

import BlogShell from "./BlogShell.jsx";
import PosterGrid from "./PosterGrid.jsx";
import { moviePosts } from "./blogData.js";
import { formatDate } from "./formatDate.js";
import PostBody from "./PostBody.jsx";
import PostPermalink from "./PostPermalink.jsx";
import { useScenePostClass } from "./ActivePostContext.js";
import "./MovieBlog.css";

const MINI_HEAD_TARGET = { yaw: 0, pitch: 0 };

function MoviePost({ post }) {
  const sceneClass = useScenePostClass(post);
  return (
    <article className={`movie-post ${sceneClass}`}>
      <div className="movie-post__meta">
        <span>{formatDate(post.date)}</span>
        <span>{post.extra.runtimeLabel}</span>
        <span>★ {post.extra.rating.toFixed(1)}</span>
        <PostPermalink id={post.id} />
      </div>
      <h2 className="movie-post__title">{post.title}</h2>
      <PostBody post={post} textClassName="movie-post__excerpt" />
      <div className="movie-post__tags">
        {post.tags.map((tag) => (
          <span key={tag} className="movie-post__tag">
            #{tag}
          </span>
        ))}
      </div>
    </article>
  );
}

function MoviePosterPanel({ onJumpTo }) {
  const [showGrid, setShowGrid] = useState(false);

  return (
    <div className="movie-poster-panel">
      <button
        type="button"
        className="movie-poster-panel__toggle"
        onClick={() => setShowGrid((v) => !v)}
        aria-expanded={showGrid}
      >
        {showGrid ? "Hide Posters" : "Browse Posters"}
      </button>

      {showGrid && <PosterGrid posts={moviePosts} onSelectPost={onJumpTo} />}
    </div>
  );
}

export default function MovieBlog({ onNavigateHome }) {
  return (
    <BlogShell
      themeClassName="movie-theme"
      posts={moviePosts}
      renderPost={(post) => <MoviePost key={post.id} post={post} />}
      miniHeadTarget={MINI_HEAD_TARGET}
      onNavigateHome={onNavigateHome}
      emptyLabel="content"
      sidebarExtra={({ onJumpTo }) => <MoviePosterPanel onJumpTo={onJumpTo} />}
    />
  );
}
